import { useEffect } from 'react';
import useAxiosPrivate from '../auth_services/useAxiosPrivate';
import { useRoutes, useNavigate, useLocation } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import AdminRoutes from './AdminRoutes.js';
import SaleRoutes from './SaleRoutes.js';
//import SettingsRoutes from './SettingsRoutes.js';
import useAuth from '../auth_services/useAuth.js';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    // Check login
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();

    // Check login onw time when load page 
    useEffect(() => {
        let path = location.pathname;
        let pathname = path.substring(0, path.indexOf("/", 1));
        if (pathname == '') pathname = path
        if (useAuth.GetToken() != null) {
            checkLogin();
        } else {
            if (
                pathname != '/register' &&
                pathname != '/billonline' &&
                pathname != '/package'
            ) {
                navigate("/login");
            }
        }
    }, []);

    // Check login every time when path change
    useEffect(() => {
        if (useAuth.GetToken() == null) {
            let path = location.pathname;
            let pathname = path.substring(0, path.indexOf("/", 1));
            if (pathname == '') pathname = path
            if (
                pathname != '/register' &&
                pathname != '/billonline' &&
                pathname != '/resetpassword' &&
                pathname != '/package'
            ) {
                navigate("/login");
            }
        } else {
            // Package expire navigate to /package/view for payment
            if (useAuth.pkUnlimit() == 'N') {
                if (useAuth.pkExpireLastDay() || !useAuth.pkRegister()) {
                    if (
                        location.pathname === '/register/package' ||
                        location.pathname === '/register/merchant_setup' ||
                        location.pathname === '/register/success' ||
                        location.pathname === '/register/welcome'
                    ) {
                        navigate(location.pathname);
                    } else {
                        navigate("/package/view");
                    }
                } else {
                    checkLogin();
                }
            }
        }
    }, [location.pathname]);

    const checkLogin = async () => {
        try {
            await axiosPrivate.get('authtoken');
            if (
                location.pathname === '/' ||
                location.pathname === '/login' ||
                location.pathname === '/register' ||
                location.pathname === '/resetpassword' ||
                location.pathname === '/package'
            ) {
                navigate('/profile');
            } else {
                navigate(location.pathname);
            }
        } catch (error) {
            if (
                location.pathname != '/register' &&
                location.pathname != '/resetpassword' &&
                location.pathname != '/package'
            ) {
                navigate("/login");
            }
        }
    }
    //**** Check login */

    return useRoutes([AdminRoutes, LoginRoutes, SaleRoutes]);
}